var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('transition',{attrs:{"mode":"out-in","appear":""}},[_c('router-view')],1),_c('notifications'),_c('no-internet-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }